module.exports = __webpack_public_path__ + "static/media/english-levels-new.b27903c4.png";